export default __webpack_public_path__ + "static/media/blog2.4c6c8979.jpeg";